import { combineReducers } from 'redux';
import homePageForm from './homePageForm';

export default combineReducers({
  homePageForm,
});
